var time1,time1a,time2,time3,time4; //debug varaibles
var departureMap  = [];
var returnMap = [];

$(document).ready(function(){
	
	departureMap  = $("#link-table-multi-prov-dep").find("tr[gr=a]").map(function(){
		$this = $(this);
		return {
				fRow: $this.get(0),
				dRow: $this.next().get(0),
				price: parseFloat($this.attr("price")),
				depDate: parseTRDate2($this.attr("firstLegDeparture")),
				arrDate: parseTRDate2($this.attr("lastLegArrival")),
				flighttime: parseFloat($this.attr("flighttime")),
				airlinename: $this.attr("airlinename")
		};
	});
	
	returnMap = $("#link-table-multi-prov-ret").find("tr[gr=a]").map(function(){
		$this = $(this);
		return {
			
			fRow: $this.get(0),
			dRow: $this.next().get(0),
			price: parseFloat($this.attr("price")),
			depDate: parseTRDate2($this.attr("firstLegDeparture")),
			arrDate: parseTRDate2($this.attr("lastLegArrival")),
			flighttime: parseFloat($this.attr("flighttime")),
			airlinename: $this.attr("airlinename")
		};
	});
		
	$("[name=sortingSearch]").change(function(){
		
		var $this = $(this).next();
		//var $option = $this.find(":selected");

		var attribute = $this.attr("data-filter-attribute-multi-prov");
		var direction = $this.attr("data-filter-direction");
		var tableType = $this.attr("data-filter-table-multi-prov");
		
		if(tableType == 'all'){
			departureMap  = sortFlightListTable( $("#link-table-multi-prov-dep"), departureMap , attribute,direction);
			returnMap = sortFlightListTable( $("#link-table-multi-prov-ret"), returnMap, attribute,direction);
		}else if(tableType == 'dep'){
			departureMap  = sortFlightListTable( $("#link-table-multi-prov-dep"), departureMap , attribute,direction);
		}else if(tableType == 'ret'){
			returnMap = sortFlightListTable( $("#link-table-multi-prov-ret"), returnMap, attribute,direction);
		}

		refreshTable2();
		
	});
	$("#sortingPriceAsc").click();
	
});

function sortFlightListTable(table, mapFlight, attribute,direction){
	
	openLoaderBox();
	
	time1 = new Date();
	
	time1a = new Date();
	
	//sortList
	for(var i = 0; i < mapFlight.length - 1; i++){
		for(var j = i + 1; j < mapFlight.length; j++){
			
			var result = mapFlight[i][attribute] > mapFlight[j][attribute] ? 1 : (mapFlight[i][attribute] < mapFlight[j][attribute] ? -1 : 0);
			if(direction == "desc"){
				result *= -1;
			}
			
			if(result == 1){
				var temp = mapFlight[i];
				mapFlight[i] = mapFlight[j];
				mapFlight[j] = temp;
			}
		}
	}
		
	
	time2 = new Date();
	
	mapFlight.each(function(){
		table.append(this.fRow);
		table.append(this.dRow);		
	});
	
	time3 = new Date();
	
	refreshTable2();
	
	closeLoaderBox();
	
	time4 = new Date();
	
	return mapFlight;
}



function parseTRDate2(dateString) {
	
	if(dateString == ""){
		return null;
	}
	
	var parts = dateString.split(' ');
	var dateParts = parts[0].split('.');
	var timeParts = parts[1].split(':');

	var date = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1], 0, 0);

	return date;
}